import { uiSettingsDefaults } from '../reducers/UiSettingsReducers';

export default (state: any) => {
  return {
    ...state,
    uiSettings: {
      ...state.uiSettings,
      ...uiSettingsDefaults,
    },
  };
};
